import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CartSidebarComponent } from './components/cart-sidebar/cart-sidebar.component';
import { BaseItemComponent } from './components/items/base-item/base-item.component';
import { HotelItemComponent } from './components/items/hotel-item/hotel-item.component';
import { TransportItemComponent } from './components/items/transport-item/transport-item.component';
import { ExperienceItemComponent } from './components/items/experience-item/experience-item.component';
import { TicketItemComponent } from './components/items/ticket-item/ticket-item.component';
import { RentACarItemComponent } from './components/items/rent-a-car-item/rent-a-car-item.component';
import { InsuranceItemComponent } from './components/items/insurance-item/insurance-item.component';
import { CurrencyConverterPurePipe } from '../currency-converter-pure.pipe';
import { TooltipConvertAmountModule } from '../tooltip-convert-amount/tooltip-convert-amount.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TooltipConvertAmountModule
  ],
  declarations: [
    CartSidebarComponent,
    BaseItemComponent,
    HotelItemComponent,
    TransportItemComponent,
    ExperienceItemComponent,
    TicketItemComponent,
    RentACarItemComponent,
    InsuranceItemComponent,
  ],
  exports: [
    CartSidebarComponent,
    HotelItemComponent,
    TransportItemComponent,
    ExperienceItemComponent,
    TicketItemComponent,
    RentACarItemComponent,
    InsuranceItemComponent
  ],
  providers: [
 CurrencyConverterPurePipe]
})
export class CartModule { }
